import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "shelf-page" }
const _hoisted_2 = {
  key: 0,
  class: "shelf-state"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("加载中...")
const _hoisted_4 = {
  key: 1,
  class: "shelf-state shelf-state--error"
}
const _hoisted_5 = { class: "shelf-state-title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "shelf-state-desc" }, "请检查链接后重试", -1)
const _hoisted_7 = {
  key: 2,
  class: "shelf-main shelf-main--pricelist"
}
const _hoisted_8 = { class: "pricelist-poster" }
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = {
  key: 1,
  class: "pricelist-poster-fallback"
}
const _hoisted_11 = { class: "shelf-name" }
const _hoisted_12 = { class: "pricelist-action" }
const _hoisted_13 = { class: "shelf-main" }
const _hoisted_14 = {
  key: 0,
  class: "shelf-covers"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 查看作品 ")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "shelf-token-arrow" }, "›", -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "shelf-overview" }
const _hoisted_22 = { class: "shelf-name" }
const _hoisted_23 = { class: "shelf-price-row" }
const _hoisted_24 = { class: "shelf-price" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "shelf-price-symbol" }, "¥", -1)
const _hoisted_26 = { class: "shelf-price-value" }
const _hoisted_27 = {
  key: 0,
  class: "shelf-price-suffix"
}
const _hoisted_28 = { class: "shelf-stats" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 0,
  class: "shelf-description"
}
const _hoisted_31 = {
  key: 1,
  class: "shelf-section"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h2", { class: "shelf-section-title" }, "委托信息", -1)
const _hoisted_33 = { class: "shelf-card shelf-delivery" }
const _hoisted_34 = {
  key: 0,
  class: "shelf-detail-row"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", null, "交付时间", -1)
const _hoisted_36 = {
  key: 1,
  class: "shelf-detail-row"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", null, "授权范围", -1)
const _hoisted_38 = {
  key: 2,
  class: "shelf-detail-row"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", null, "发布权限", -1)
const _hoisted_40 = {
  key: 3,
  class: "shelf-detail-row"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", null, "交付格式", -1)
const _hoisted_42 = /*#__PURE__*/_createStaticVNode("<section class=\"shelf-section\"><h2 class=\"shelf-section-title\">购前须知</h2><div class=\"shelf-card shelf-notice\"><div class=\"shelf-notice-title\">出现纠纷可联系平台客服</div><img class=\"shelf-notice-image\" src=\"https://cdn.qiandaoapp.com/interior/images/b3d77f69b048481898cb7c2d32c694d1.png!mfit_w750_h750_jpg\" alt=\"购前须知\"></div></section>", 1)
const _hoisted_43 = { class: "shelf-action" }
const _hoisted_44 = { class: "shelf-action-info" }
const _hoisted_45 = { class: "shelf-action-price" }
const _hoisted_46 = {
  key: 0,
  class: "shelf-action-stock"
}

import { computed, onMounted, ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { useRoute, useRouter } from "vue-router";
import {
  Loading as VanLoading,
  NavBar as VanNavBar,
  Sticky as VanSticky,
  showImagePreview,
} from "vant";
import dayjs from "dayjs";
import DownloadBanner from "@/components/DownloadBanner/index.vue";
import MainButton from "@/components/MainButton/index.vue";
import ShelfApi from "@/apis/shelf";
import NftApi from "@/apis";
import { invokeAppByYYB } from "@/utils/mob";
import { useUsersStore } from "@/store/user";
import HOSTS from "@/http/hosts";

interface ShelfAttachment {
  url: string;
  relatedId?: string;
  relatedType?: string;
}

interface ShelfCommission {
  commissionCompleteBefore?: string | number;
  isCompleteStartFromAccept?: boolean;
  scopeOfAuthorization?: string;
  publishPermission?: string;
  deliveryFormat?: string;
}

interface ShelfPrice {
  value?: string | number;
  valueV2?: string;
  suffix?: string;
}

interface ShelfStatus {
  isOnShelf?: boolean;
  isSoldOut?: boolean;
}

interface ShelfSimpleInfo {
  name?: string;
  description?: string;
  attachments?: ShelfAttachment[];
  images?: ShelfAttachment[];
  price?: ShelfPrice;
  sellTime?: string | number;
  status?: ShelfStatus;
}

interface ShelfProduct {
  stock?: string | number;
  disable?: boolean;
  isSoldOut?: boolean;
}

interface ShelfPspu {
  products?: ShelfProduct[];
}

interface ShelfDetailInfo {
  sellerId?: string;
  sellTime?: string | number;
  productType?: string;
  commission?: ShelfCommission;
  pspus?: ShelfPspu[];
  showAvailableInventory?: boolean;
  stats?: {
    soldAmount?: string | number;
    favoriteCount?: string | number;
  };
  status?: ShelfStatus;
}

interface ConfigItem {
  id: string;
  name: string;
}

type PublishConfig = Record<string, ConfigItem[]>;

interface ApiResponse<T> {
  code?: string | number;
  message?: string;
  data?: T;
}

interface PublishConfigResponse {
  data?: {
    publishConfig?: PublishConfig;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const usersStore = useUsersStore();
const { userInfo, getIsLogin } = storeToRefs(usersStore);

const shelfId = ref("");
const loading = ref(true);
const errorMessage = ref("");
const simpleInfo = ref<ShelfSimpleInfo>({});
const detailInfo = ref<ShelfDetailInfo>({});
const publishConfig = ref<PublishConfig>({});

const attachments = computed<ShelfAttachment[]>(() => {
  const list = simpleInfo.value?.attachments?.length
    ? simpleInfo.value.attachments
    : simpleInfo.value?.images || [];
  return list.filter((item: ShelfAttachment) => item?.url);
});

const commission = computed<ShelfCommission>(
  () => detailInfo.value?.commission || {}
);

// 价目表（commission_sheet）分享落地页：只展示海报图 + 唤起 App 入口
const isCommissionSheet = computed(
  () => detailInfo.value?.productType === "commission_sheet"
);

const posterLoadFailed = ref(false);

const posterUrl = computed(
  () =>
    `${
      HOSTS.api
    }/z/poster-web/_poster/linjie-price-list?shelfId=${encodeURIComponent(
      shelfId.value
    )}`
);

const displayPrice = computed(() => {
  const price = simpleInfo.value?.price || {};
  return price.valueV2 || price.value || 0;
});

const priceSuffix = computed(() => simpleInfo.value?.price?.suffix || "");

const products = computed<ShelfProduct[]>(() =>
  (detailInfo.value?.pspus || []).flatMap((item) => item.products || [])
);

const totalStock = computed(() =>
  products.value.reduce((sum, item) => sum + Number(item.stock || 0), 0)
);

const isOwner = computed(
  () =>
    Boolean(getIsLogin.value) &&
    String(detailInfo.value?.sellerId || "") ===
      String(userInfo.value?.userId || "")
);

const isFutureSelling = computed(() => {
  const sellTime = Number(
    simpleInfo.value?.sellTime || detailInfo.value?.sellTime || 0
  );
  return sellTime > Date.now();
});

const isSoldOut = computed(() => {
  if (detailInfo.value?.status?.isSoldOut) return true;
  return (
    products.value.length > 0 &&
    products.value.every(
      (item) => item.isSoldOut || item.disable || Number(item.stock || 0) <= 0
    )
  );
});

const isOffShelf = computed(
  () =>
    simpleInfo.value?.status?.isOnShelf === false ||
    detailInfo.value?.status?.isOnShelf === false
);

const actionDisabled = computed(
  () =>
    !isOwner.value &&
    (isFutureSelling.value || isSoldOut.value || isOffShelf.value)
);

const actionText = computed(() => {
  if (isOwner.value) return "请去App操作";
  if (isFutureSelling.value) return "未开售";
  return "购买";
});

const deadlineText = computed(() => {
  const value = Number(commission.value.commissionCompleteBefore || 0);
  if (!value) return "";
  if (commission.value.isCompleteStartFromAccept) {
    const days = Math.max(1, Math.round(value / 86400000));
    return `接单后 ${days} 天`;
  }
  return dayjs(value).format("YYYY-MM-DD");
});

const hasDeliveryInfo = computed(() =>
  Boolean(
    deadlineText.value ||
      commission.value.scopeOfAuthorization ||
      commission.value.publishPermission ||
      commission.value.deliveryFormat
  )
);

const appendImageStyle = (url: string) => {
  if (!url || url.includes("!")) return url;
  return `${url}!mfit_w750_h750_jpg`;
};

const previewImage = (index: number) => {
  showImagePreview({
    images: attachments.value.map((item) => item.url),
    startPosition: index,
  });
};

const toTokenPage = (relatedId: string) => {
  const query: Record<string, string> = { tokenId: relatedId };
  if (typeof route.query._env === "string") query._env = route.query._env;
  router.push({ path: "/token-detail", query });
};

const invokeShelfApp = () => {
  invokeAppByYYB({
    targetPath: isCommissionSheet.value
      ? "commission/sheet/detail"
      : "shelf/detail",
    params: { shelfId: shelfId.value },
  });
};

const onClickLeft = () => {
  if (window.history.length > 1) router.back();
  else router.push("/");
};

const configName = (key: string, value?: string) => {
  if (!value) return "";
  const list = publishConfig.value?.[key] || [];
  return list.find((item) => item.id === value)?.name || value;
};

const loadPublishConfig = async () => {
  try {
    const response =
      (await NftApi.getSpPublishConfig()) as PublishConfigResponse;
    publishConfig.value = response?.data?.publishConfig || {};
  } catch (error) {
    console.error("Failed to load commission config", error);
  }
};

const loadShelf = async () => {
  const value =
    typeof route.query.shelfId === "string" ? route.query.shelfId : "";
  shelfId.value = value;
  simpleInfo.value = {};
  detailInfo.value = {};
  errorMessage.value = "";
  posterLoadFailed.value = false;

  if (!value) {
    loading.value = false;
    errorMessage.value = "橱窗不存在或已删除";
    return;
  }

  loading.value = true;
  try {
    const [simpleResponse, detailResponse] = (await Promise.all([
      ShelfApi.getSimpleInfo(value),
      ShelfApi.getDetail(value),
    ])) as [ApiResponse<ShelfSimpleInfo>, ApiResponse<ShelfDetailInfo>];
    if (
      String(simpleResponse?.code) !== "0" ||
      String(detailResponse?.code) !== "0"
    ) {
      throw new Error(
        simpleResponse?.message || detailResponse?.message || "Shelf not found"
      );
    }
    simpleInfo.value = simpleResponse.data || {};
    detailInfo.value = detailResponse.data || {};
  } catch (error) {
    console.error("Failed to load shelf detail", error);
    errorMessage.value = "橱窗不存在或已删除";
  } finally {
    loading.value = false;
  }
};

watch(
  () => route.query.shelfId,
  () => loadShelf()
);

onMounted(() => {
  loadShelf();
  loadPublishConfig();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(VanSticky), null, {
      default: _withCtx(() => [
        _createVNode(_unref(VanNavBar), {
          "left-arrow": "",
          title: "橱窗详情",
          onClickLeft: onClickLeft
        })
      ]),
      _: 1
    }),
    _createVNode(DownloadBanner, { onOnInvokeApp: invokeShelfApp }),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(VanLoading), {
            color: "#7247dc",
            size: "32px"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]))
      : (errorMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(errorMessage.value), 1),
            _hoisted_6
          ]))
        : (_unref(isCommissionSheet))
          ? (_openBlock(), _createElementBlock("main", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (!posterLoadFailed.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "pricelist-poster-image",
                      src: _unref(posterUrl),
                      alt: simpleInfo.value.name,
                      onError: _cache[0] || (_cache[0] = ($event: any) => (posterLoadFailed.value = true))
                    }, null, 40, _hoisted_9))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("h1", _hoisted_11, _toDisplayString(simpleInfo.value.name), 1)
                    ]))
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(MainButton, {
                  full: "",
                  text: "打开 App 查看价目表",
                  onOnInvokeApp: invokeShelfApp
                })
              ])
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("main", _hoisted_13, [
                (_unref(attachments).length)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(attachments), (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `${item.url}-${index}`,
                          class: "shelf-cover",
                          onClick: ($event: any) => (previewImage(index))
                        }, [
                          _createElementVNode("img", {
                            class: "shelf-cover-image",
                            src: appendImageStyle(item.url),
                            alt: simpleInfo.value.name
                          }, null, 8, _hoisted_16),
                          (item.relatedType === 'TOKEN' && item.relatedId)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "shelf-token-entry",
                                type: "button",
                                onClick: _withModifiers(($event: any) => (toTokenPage(item.relatedId)), ["stop"])
                              }, _hoisted_20, 8, _hoisted_17))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_15))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("section", _hoisted_21, [
                  _createElementVNode("h1", _hoisted_22, _toDisplayString(simpleInfo.value.name), 1),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(displayPrice)), 1),
                      (_unref(priceSuffix))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_unref(priceSuffix)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      (detailInfo.value.showAvailableInventory)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, " 库存 " + _toDisplayString(_unref(totalStock)), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, "卖出 " + _toDisplayString(detailInfo.value.stats?.soldAmount || 0), 1),
                      _createElementVNode("span", null, "收藏 " + _toDisplayString(detailInfo.value.stats?.favoriteCount || 0), 1)
                    ])
                  ]),
                  (simpleInfo.value.description)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(simpleInfo.value.description), 1))
                    : _createCommentVNode("", true)
                ]),
                (_unref(hasDeliveryInfo))
                  ? (_openBlock(), _createElementBlock("section", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("div", _hoisted_33, [
                        (_unref(deadlineText))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              _hoisted_35,
                              _createElementVNode("strong", null, _toDisplayString(_unref(deadlineText)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(commission).scopeOfAuthorization)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                              _hoisted_37,
                              _createElementVNode("strong", null, _toDisplayString(configName(
                  "authorizationScopes",
                  _unref(commission).scopeOfAuthorization
                )), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(commission).publishPermission)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                              _hoisted_39,
                              _createElementVNode("strong", null, _toDisplayString(configName("permissions", _unref(commission).publishPermission)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(commission).deliveryFormat)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              _hoisted_41,
                              _createElementVNode("strong", null, _toDisplayString(configName("formats", _unref(commission).deliveryFormat)), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_42
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, " ¥" + _toDisplayString(_unref(displayPrice)) + _toDisplayString(_unref(priceSuffix)), 1),
                  (detailInfo.value.showAvailableInventory)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, " 库存 " + _toDisplayString(_unref(totalStock)), 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(MainButton, {
                  text: _unref(actionText),
                  disabled: _unref(actionDisabled),
                  inactivated: _unref(isOwner),
                  onOnInvokeApp: invokeShelfApp
                }, null, 8, ["text", "disabled", "inactivated"])
              ])
            ], 64))
  ]))
}
}

})